<template>
  <header class="header">
    <div style="width: 100%" class="header-title">
      <a class="toggle" @click="toggleMenu">
        <!-- v-if="!hideToggle && isIconMenuVisible" -->
        <i style="font-size: 1rem" class="fa fa-lg fas fa-bars"></i>
      </a>
      <div class="title">
        <router-link :style="fontSizeTitleHome" to="/"
          ><div class="navbar-brand">{{ title }}</div></router-link
        >
      </div>

      <form role="search" class="bd-search d-none d-md-block mr-2">
        <span
          class="algolia-autocomplete algolia-autocomplete-left"
          style="position: relative; display: inline-block; direction: ltr"
          ><b-form-input
            v-model.trim="informationSearch"
            type="search"
            placeholder="Digite para filtrar..."
            @input="delayedLoadArticles()"
            style="
              position: relative;
              vertical-align: top;
              height: 30px;
              width: 300px;
            "
          />
          <span
            class="ds-dropdown-menu ds-with-1"
            id="algolia-autocomplete-listbox-0"
            style="
              position: absolute;
              top: 100%;
              z-index: 100;
              left: 0px;
              right: auto;
            "
            :style="displaySpan"
            ><div style="height: 200px; overflow: auto; position: relative">
              <ul
                v-show="articlesLegth"
                v-for="article in articles"
                :key="article.id"
                class="list-group list-group-flush"
              >
                <li
                  style="
                    padding: 10px 5px;
                    color: #545454;
                    word-wrap: break-word;
                    cursor: pointer;
                  "
                  class="list-group-item article-item"
                  @click="showArticle(article)"
                >
                  <mdicon
                    style="color: #aaa"
                    size="25"
                    name="file-document-outline"
                  />
                  {{ article.name }}
                </li>
              </ul>
              <div v-show="progress" class="text-center">
                <p>Carregando...</p>
                <b-spinner variant="dark" label="Loading..."></b-spinner>
              </div>
              <div
                v-show="articles.length === 0 && !progress"
                class="text-center"
              >
                <p>Sua filtragem não encontrou nenhum artigo correspondente.</p>
              </div>
            </div>
          </span></span
        >
      </form>

      <!-- <div class="menu-filter">
      <i style="font-size: 1rem" class="fa fa-search fa-lg"></i>
      <input
        type="text"
        placeholder="O que você está procurando?"
        class="filter-field"
      />
      </div> -->

      <div style="height: 100%" class="d-flex div-container">
        <a
          href="https://www.facebook.com/lcsistemas"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <svg
            style="color: #d3d3d4; font-size: 1.4rem"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="facebook-square"
            class="svg-inline--fa fa-facebook-square fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
            ></path>
          </svg>
        </a>

        <a
          href="https://www.instagram.com/lcsistemas"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <svg
            style="color: #d3d3d4; font-size: 1.4rem"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="instagram"
            class="svg-inline--fa fa-instagram fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
            ></path>
          </svg>
        </a>

        <a
          href="https://www.youtube.com/channel/UCz685PN2suQHDUtspZhuitw"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <svg
            style="color: #d3d3d4; font-size: 1.2rem; margin-top: 1px"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="youtube"
            class="svg-inline--fa fa-youtube fa-w-18"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
          >
            <path
              fill="currentColor"
              d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
            ></path>
          </svg>
        </a>

        <a
          href="https://play.google.com/store/apps/dev?id=7127361085405678650"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <svg
            style="color: #d3d3d4; font-size: 1.1rem; margin-top: 2px"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="google-play"
            class="svg-inline--fa fa-google-play fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
            ></path>
          </svg>
        </a>

        <a
          href="https://apps.apple.com/br/developer/lc-sistemas/id1645586987"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <svg
            style="color: #d3d3d4; font-size: 1.4rem"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="App Store"
            class="svg-inline--fa fa-w-14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) -->
            <path
              fill="currentColor"
              d="M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
            />
          </svg>
        </a>

        <a
          href="https://www.linkedin.com/company/lcsistemas"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <svg
            style="color: #d3d3d4; font-size: 1.4rem"
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="linkedin"
            class="svg-inline--fa fa-linkedin fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
            ></path>
          </svg>
        </a>

        <a
          href="https://lcsistemas.com.br"
          target="_blank"
          class="div-icon d-none d-lg-block"
        >
          <font-awesome-icon
            color="#d3d3d4"
            style="font-size: 1.4rem"
            icon="globe-americas"
          />
        </a>
      </div>
      <UserDropdown v-if="!hideUserDropdown" />
      <div v-else @click="login" class="background-icon m-2">
        <font-awesome-icon
          class="icon"
          color="#fff"
          icon="user-circle"
          swap-opacity
        />
      </div>
    </div>
    <div
      style="border-top: 1px solid #4e5050; width: 100%"
      v-if="isInformationSearchSm"
      class="header-title"
    >
      <form role="search" class="bd-search mr-2">
        <span
          class="algolia-autocomplete algolia-autocomplete-left"
          style="position: relative; display: inline-block; direction: ltr"
          ><b-form-input
            v-model.trim="informationSearch"
            type="search"
            placeholder="Digite para filtrar..."
            style="
              position: relative;
              vertical-align: top;
              height: 30px;
              width: 250px;
            "
          />
          <span
            class="ds-dropdown-menu ds-with-1"
            id="algolia-autocomplete-listbox-0"
            style="
              position: absolute;
              top: 100%;
              z-index: 100;
              left: 0px;
              right: auto;
            "
            :style="displaySpan"
            ><div style="height: 200px; overflow: auto; position: relative">
              <ul
                v-show="articlesLegth"
                v-for="article in articles"
                :key="article.id"
                class="list-group list-group-flush"
              >
                <li
                  style="
                    padding: 10px 5px;
                    color: #545454;
                    word-wrap: break-word;
                    cursor: pointer;
                  "
                  class="list-group-item article-item"
                  @click="showArticle(article)"
                >
                  <mdicon
                    style="color: #aaa"
                    size="25"
                    name="file-document-outline"
                  />
                  {{ article.name }}
                </li>
              </ul>
              <div v-show="progress" class="text-center">
                <p>Carregando...</p>
                <b-spinner variant="dark" label="Loading..."></b-spinner>
              </div>
              <div
                v-show="articles.length === 0 && !progress"
                class="text-center"
              >
                <p>Sua filtragem não encontrou nenhum artigo correspondente.</p>
              </div>
            </div></span
          ></span
        >
      </form>
    </div>
  </header>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import UserDropdown from "./UserDropdown.vue";
import { mapState } from "vuex";
export default {
  name: "Header",
  components: { UserDropdown },
  data: function () {
    return {
      informationSearch: "",
      articles: [],
      progress: false,
      debounceTimer: null,
    };
  },
  props: {
    title: String,
    hideToggle: Boolean,
    hideUserDropdown: Boolean,
  },
  computed: {
    ...mapState(["isIconMenuVisible"]),
    // marginLeft() {
    //   return !(!this.hideToggle && this.isIconMenuVisible) ? "ml-4" : "ml-0";
    // },
    displaySpan() {
      return this.informationSearch.length > 0
        ? "display: block"
        : "display: none";
    },
    articlesLegth() {
      // console.log(this.articles.length);
      return this.articles.length > 0 ? true : false;
    },
    isInformationSearchSm() {
      return this.$mq === "xs" || this.$mq === "sm" ? true : false;
    },
    fontSizeTitleHome() {
      return this.$mq === "sm" || this.$mq === "md" ? "font-size: 1rem" : "";
    },
  },
  methods: {
    toggleMenu() {
      this.$store.commit("toggleMenu");
    },
    login() {
      this.$store.commit("toggleMenu", false);
      this.$router.push({
        name: "login",
      });
    },
    showArticle(article) {
      this.$router.push({
        name: "articleById",
        params: {
          name: `${article.name.toLowerCase().replace(/ /g, "-")}-${
            article.id
          }`,
        },
      });
      this.informationSearch = "";
      // window.location.reload();
    },
    delayedLoadArticles() {
      // eslint-disable-next-line
      console.log("delayedLoadArticles");
      // Cancela o timer existente se houver um.
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // Define um novo timer para executar a pesquisa após 500ms (ajuste o tempo conforme necessário).
      this.debounceTimer = setTimeout(() => {
        if (this.informationSearch.length > 0) {
        this.loadArticles();
        }
      }, 500); // Tempo de espera de 200ms antes de executar a pesquisa.
    },
    loadArticles() {
      this.progress = true;
      this.articles = [];
      const url = `${baseApiUrl}/api/publico/artigos/header-search`;

      axios
        .get(url, {
          params: {
            name: this.informationSearch,
          },
        })
        .then((res) => {
          this.progress = false;
          this.articles = res.data;
        });
    },
  },
};
</script>

<style>
.header {
  grid-area: header;
  /* background: linear-gradient(to right, #212529, #6c757d); */
  background-color: #232526;

  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 0.9rem;
  align-items: center;
}

.header-title {
  height: 100%;
  grid-area: header;
  /* background: linear-gradient(to right, #212529, #6c757d); */
  background-color: #232526;

  display: flex;
  justify-content: center;
  font-size: 0.9rem;
  align-items: center;
}

.header-title .menu-filter {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #aaa;
}

.header-title .menu-filter i {
  color: #aaa;
  margin-right: 10px;
}

.header-title
  .algolia-autocomplete
  .algolia-autocomplete-left
  .ds-dropdown-menu {
  left: 0 !important;
  right: inherit !important;
}

.algolia-autocomplete .ds-dropdown-menu {
  top: -6px;
  border-radius: 4px;
  margin: 6px 0 0;
  padding: 0;
  text-align: left;
  height: auto;
  position: relative;
  background: transparent;
  border: none;
  z-index: 999;
  max-width: 600px;
  min-width: 500px;
  box-shadow: 0 1px 0 0 rgb(0 0 0 / 20%), 0 2px 3px 0 rgb(0 0 0 / 10%);
}

.algolia-autocomplete .ds-dropdown-menu {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175) !important;
}

@media (min-width: 768px) {
  .algolia-autocomplete .ds-dropdown-menu {
    width: 175%;
  }
}

.algolia-autocomplete .ds-dropdown-menu {
  width: 100%;
  min-width: 0 !important;
  max-width: none !important;
  padding: 0 0 !important;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 18%);
}

header input {
  height: 30px;
  padding: 10px;
  min-width: 210px;
  color: #232526;
  font-size: 1rem;
  border: 0;
  outline: 0;
  background-color: #fff;
}

.div-container {
  height: 100%;
  border-left: solid #4e5050 1px;
}

.div-icon {
  cursor: pointer;
  margin: 0px;
  height: 100%;
  border-right: solid #4e5050 1px;
  align-items: center;
  padding: 13px 10px 10px 10px;
}

.background-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
  border-radius: 50%;
  background-color: #aaaaab;
}

.icon {
  /* background-color: #fff; */
  font-size: 2rem;
  margin: 0px;
}

.div-icon:hover {
  background-color: rgba(52, 58, 68);
}

.title {
  font: 400 12px/20px "open sans", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: #fff;
  flex-grow: 1;
  text-align: start;
}

.title a {
  color: #fff;
  font-size: 1.3rem;
  text-decoration: none;
}

@media only screen and (max-width: 320px) {
  .navbar-brand {
    margin-right: 10px !important;
    font-size: 1rem !important;
  }
}

.title a:hover {
  color: #fff;
  text-decoration: none;
}

header .toggle {
  cursor: pointer;
  width: 60px;
  height: 100%;
  color: #fff;
  justify-self: flex-start;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

header a.toggle:hover {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
  text-decoration: none;
}
</style>